import { all } from 'redux-saga/effects';

import { applicantsSagas } from './applicants';
import { applicationDataCollectionSagas } from './applicationDataCollection';
import { applicationsSagas } from './applications';
import { assetsSagas } from './assets';
import { brokerInterviewsSagas } from './brokerInterviews';
import { brokerInterviewsGuarantorSagas } from './brokerInterviewsGuarantor';
import { companiesSagas } from './companies';
import { conveyancingSagas } from './conveyancing';
import { creditReportsSagas } from './creditReports';
import { customersSagas } from './customers';
import { employmentsSagas } from './employments';
import { expensesSagas } from './expenses';
import { financialSituationsSagas } from './financialSituations';
import { incomesSagas } from './incomes';
import { invitationsSagas } from './invitations';
import { leadSagas } from './lead';
import { liabilitiesSagas } from './liabilities';
import { postProductSelectSagas } from './postProductSelect';
import { productPreferencesSagas } from './productPreferences';
import { productSelectionsSagas } from './productSelections';
import { relatedPartySagas } from './relatedParty';
import { requiredActionConditionsSagas } from './requiredActionConditions';

export default function* rootSaga() {
  yield all([
    applicationsSagas(),
    applicationDataCollectionSagas(),
    applicantsSagas(),
    assetsSagas(),
    brokerInterviewsSagas(),
    brokerInterviewsGuarantorSagas(),
    companiesSagas(),
    conveyancingSagas(),
    creditReportsSagas(),
    customersSagas(),
    employmentsSagas(),
    expensesSagas(),
    financialSituationsSagas(),
    incomesSagas(),
    invitationsSagas(),
    leadSagas(),
    liabilitiesSagas(),
    productPreferencesSagas(),
    productSelectionsSagas(),
    postProductSelectSagas(),
    relatedPartySagas(),
    requiredActionConditionsSagas(),
  ]);
}
